module.exports = __webpack_public_path__ + "static/img/bao.5f158a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/bao.png
// module id = axfj
// module chunks = 2